<template>
  <div class="big">
    <el-dialog
      title="新增兑换码"
      :visible.sync="dialog"
      width="370px"
      center
      :close-on-click-modal="false"
    >
      <div style="padding: 20px">
        <div>
          <el-radio
            v-model="exchange_type"
            :label="2"
          >季卡</el-radio>
          <el-radio
            v-model="exchange_type"
            :label="1"
          >年卡</el-radio>
        </div>
        <div style="margin: 16px 0">
          <span>有效天数</span>
          <el-input-number
            v-model="expire_day"
            placeholder="输入有效天数"
            style="width: 200px; margin: 0 5px 0 8px"
            :controls="false"
            :min="1"
            :max="999"
            :precision="0"
            :step="1"
          ></el-input-number>天
        </div>
        <div>
          <span>生成个数</span>
          <el-input-number
            v-model="total"
            placeholder="输入"
            style="width: 200px; margin: 0 5px 0 8px"
            :controls="false"
            :min="1"
            :max="99"
            :precision="0"
            :step="1"
          ></el-input-number>个
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          @click="dialog = false"
          style="width: 92px"
          size="medium"
        >取 消</el-button>
        <el-button
          type="primary"
          @click="submit"
          style="width: 92px"
          size="medium"
        >确 定</el-button>
      </div>
    </el-dialog>
    <div class="page_title">会员兑换码</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div>
          <div class="box">
            <div class="flex between">
              <div class="searchbox">
                <span>兑换码</span>
                <el-input
                  v-model="keywords"
                  style="width: 160px; margin: 0 10px 0 5px"
                  @input="search"
                  clearable
                ></el-input>

                <el-button
                  type="info"
                  style="background-color: #eceff2; color: #747981"
                  @click="search"
                >查询</el-button>
                <span style="margin: 0 10px">状态</span>
                <el-radio
                  v-model="exchange_status"
                  :label="0"
                  @change="search"
                >全部</el-radio>
                <el-radio
                  v-model="exchange_status"
                  :label="1"
                  @change="search"
                >已兑换</el-radio>
                <el-radio
                  v-model="exchange_status"
                  :label="2"
                  @change="search"
                >未兑换</el-radio>
                <el-radio
                  v-model="exchange_status"
                  :label="3"
                  @change="search"
                >已过期</el-radio>
              </div>
              <el-button
                type="primary"
                @click="addCode"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('358') : false
                "
              >新增兑换码</el-button>
            </div>
            <div style="border: solid 1px #c9cbd6">
              <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%; min-width: 1000px"
                :header-cell-style="{ background: '#F5F5F5' }"
              >
                <el-table-column
                  label="排序"
                  type="index"
                ></el-table-column>
                <el-table-column
                  label="兑换码"
                  prop="exchange_code"
                ></el-table-column>
                <el-table-column label="兑换种类">
                  <template slot-scope="scope">
                    <span v-if="scope.row.exchange_type == 1">年卡</span>
                    <span v-if="scope.row.exchange_type == 2">季卡</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="创建时间"
                  prop="create_time"
                ></el-table-column>
                <el-table-column
                  label="过期时间"
                  prop="expire_time"
                ></el-table-column>
                <el-table-column label="状态">
                  <template slot-scope="scope">
                    <span v-if="scope.row.user_id > 0">已兑换</span>
                    <span v-if="
                        scope.row.user_id == 0 &&
                        scope.row.now_time < scope.row.expire_time
                      ">未兑换</span>
                    <span v-if="
                        scope.row.user_id == 0 &&
                        scope.row.now_time > scope.row.expire_time
                      ">已过期</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="兑换人手机号"
                  prop="phone"
                ></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      @click="delCode(scope.row.id)"
                      :disabled="
                        module_id_array[0]
                          ? !module_id_array.includes('359')
                          : false
                      "
                    >删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div>
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="10"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                style="margin:20px 0"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      keywords: '',
      exchange_status: 0,
      dialog: false,
      exchange_type: 2,
      expire_day: '',
      total: ''
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        keywords: this.keywords,
        exchange_status: this.exchange_status
      };

      this.axios
        .post('platform/shop/getUserExchangeCodeList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list.map((item) => {
              item.create_time = moment
                .unix(item.create_time)
                .format('YYYY-MM-DD HH:mm');
              item.expire_time = moment
                .unix(item.expire_time)
                .format('YYYY-MM-DD HH:mm');
              item.now_time = moment(Date.now()).format('YYYY-MM-DD HH:mm');
              return item;
            });
            this.totalNum = res.data.total;
          }
        });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据的条数
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //当前第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //新增
    addCode() {
      this.exchange_type = 2;
      this.expire_day = '';
      this.total = '';
      this.dialog = true;
    },
    //新增提交
    submit() {
      let data = {
        exchange_type: this.exchange_type,
        expire_day: this.expire_day,
        total: this.total
      };
      this.axios.post('platform/shop/addUserExchangeCode', data).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功');
          this.dialog = false;
          this.getList();
        }
      });
    },
    //删除
    delCode(id) {
      this.axios
        .post('platform/shop/delUserExchangeCode', { id })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.getList();
          }
        });
    }
  },
  created() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .searchbox {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.videobox {
  width: 100px;
  height: 70px;
  position: relative;
  cursor: pointer;
  .videoimg {
    width: 100%;
    height: 100%;
  }
  .onvideo {
    width: 30px;
    position: absolute;
    top: 20px;
    left: 35px;
  }
}
.imgbox {
  display: flex;
  padding: 30px;
  box-sizing: border-box;
  justify-content: space-between;
}
.uploadimg {
  width: 242px;
  height: 182px;
  box-sizing: border-box;
  background-color: #fff;
  border: dashed 1px #d6d6d6;

  .avatar {
    width: 240px;
    height: 180px;
  }
  .uploader-icon {
    padding-top: 30px;
    line-height: 30px;
    color: #669961;
  }
}
</style>
<style lang="scss">
.mydialog .mydia .el-dialog__header {
  border-radius: 5px 5px 0 0;
  border-bottom: solid 1px #dcdcde;
  text-align: left;
  font-weight: 600;
}

.mydialog .mydia .el-dialog {
  border-radius: 5px;
}

.mydialog .mydia .el-dialog__body {
  padding: 0px 0px 30px;
  color: #262626;
}
</style>